import { featureFlags } from '@config/featureFlags';
import { useCurrentUser } from '@hooks/useCurrentUser';

/**
 * Whether the helper feed is enabled for the current viewer.
 *
 * Single source of truth for the helper-feed gate. The feature ships dark behind
 * `featureFlags.helperFeed` for everyone EXCEPT Meetball platform admins
 * (`has_extra_options`), who get it in production for dogfooding ("make the flag
 * true for admins"). Mirrors the `suggestedHelpers` admin-gating precedent
 * (`QuestionDetails.tsx`: `user?.has_extra_options || featureFlags.suggestedHelpers`)
 * and the `has_extra_options` server-controlled admin flag that `AdminRoute` gates on.
 *
 * Returns:
 *  - `true` for admins regardless of the flag (feature fully ON: count, bell sum,
 *    live SSE tick, tab/banner/primer/smart-landing/analytics).
 *  - `featureFlags.helperFeed` otherwise, so non-admins stay fully DARK while the
 *    flag is off, and the feature launches for everyone when it flips on.
 */
export function useHelperFeedEnabled(): boolean {
  const { user } = useCurrentUser();
  return Boolean(user?.has_extra_options) || featureFlags.helperFeed;
}
